(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flash-sale-bar"]) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-tn-flash-bar]');
  if (!bar) return;

  // new Date(iso) honors the offset in the string, so the deadline is the same
  // absolute instant for every visitor regardless of their local timezone.
  var end = new Date(bar.getAttribute('data-ends-at')).getTime();
  if (isNaN(end)) return;

  var inner = bar.querySelector('[data-tn-flash-inner]');
  var live = bar.querySelector('[data-tn-flash-live]');
  var sec = bar.querySelector('[data-tn-flash-sec]');
  if (!inner || !live || !sec) return;

  var lastCoarse = null;
  var timer;

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function tick() {
    var diff = end - Date.now();

    if (diff <= 0) {
      clearInterval(timer);
      inner.textContent = bar.getAttribute('data-expired-text') || '';
      document.documentElement.setAttribute('data-flash-sale', 'expired');
      return;
    }

    var t = Math.floor(diff / 1000);
    var d = Math.floor(t / 86400);
    var h = Math.floor((t % 86400) / 3600);
    var m = Math.floor((t % 3600) / 60);
    var s = t % 60;

    // Drop leading units once they hit zero. Only the highest-order units are
    // dropped; interior zeros (e.g. "2d 0h 5m") are kept.
    var coarse = '';
    if (d > 0) coarse += d + 'd ';
    if (d > 0 || h > 0) coarse += h + 'h ';
    if (d > 0 || h > 0 || m > 0) coarse += m + 'm';

    // Rewrite the live region only when the coarse value changes (once/min).
    if (coarse !== lastCoarse) {
      live.textContent = coarse;
      lastCoarse = coarse;
    }

    // Seconds live outside the aria-live region, so ticking is visual only.
    sec.textContent = (coarse ? ' ' : '') + pad(s) + 's';
  }

  tick();
  timer = setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tn-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  var items = document.querySelectorAll('.tn-faq__item');
  items.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (item.open) {
        items.forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tn-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-tn-gallery]').forEach(function (root) {
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-tn-thumb]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-tn-slide]'));
    var strip = root.querySelector('.tn-hero__thumbs');
    if (!strip || !thumbs.length || thumbs.length !== slides.length) return;

    // Only collapse the stack once JS is confirmed running. If this line is
    // never reached the visitor keeps all five slides stacked and readable.
    root.classList.add('tn-hero__gallery--js');

    var current = 0;

    function select(index, moveFocus) {
      current = (index + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });

      thumbs.forEach(function (thumb, i) {
        var active = i === current;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
        // Roving tabindex: the strip is one tab stop, arrows move within it.
        thumb.tabIndex = active ? 0 : -1;
      });

      if (moveFocus) thumbs[current].focus();
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        select(i, false);
      });
    });

    strip.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        select(current + 1, true);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        select(current - 1, true);
      } else if (e.key === 'Home') {
        e.preventDefault();
        select(0, true);
      } else if (e.key === 'End') {
        e.preventDefault();
        select(slides.length - 1, true);
      }
    });

    select(0, false);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tn-lie-detector"] && !Shopify.designMode) return;
  try {
    
(function () {
  var FALLBACK_MSG = 'Copy failed. Select the label above and copy it manually.';

  document.querySelectorAll('.tn-lie').forEach(function (root) {
    var source = root.querySelector('.tn-lie__source');
    var status = root.querySelector('.tn-lie__status');
    if (!source || !status) return;

    var labelText = source.value;
    var hideTimer;

    function announce(message, ok) {
      window.clearTimeout(hideTimer);
      // Re-announce identical messages on repeat clicks.
      status.textContent = '';
      status.textContent = message;
      status.classList.toggle('tn-lie__status--error', !ok);
      status.classList.add('tn-lie__status--visible');
      hideTimer = window.setTimeout(function () {
        status.classList.remove('tn-lie__status--visible');
      }, 5000);
    }

    // execCommand path for insecure contexts and older Safari.
    function legacyCopy(text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '0';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);

      var ok = false;
      try {
        ta.select();
        ta.setSelectionRange(0, ta.value.length);
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }

      document.body.removeChild(ta);
      return ok;
    }

    function fallbackCopy(text, confirmMsg) {
      var ok = legacyCopy(text);
      announce(ok ? confirmMsg : FALLBACK_MSG, ok);
    }

    function copy(text, confirmMsg) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(
          function () {
            announce(confirmMsg, true);
          },
          function () {
            fallbackCopy(text, confirmMsg);
          }
        );
        return;
      }
      fallbackCopy(text, confirmMsg);
    }

    root.querySelectorAll('[data-tn-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var question = btn.getAttribute('data-question');
        var text = question ? labelText + '\n\n' + question : labelText;
        copy(text, btn.getAttribute('data-confirm') || 'Copied.');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
